import React from "react"
import {connect} from "react-redux"
import {Field, reduxForm, getFormValues, change } from "redux-form"
import {SelectMenu} from "../../components/forms";

import { NewCustomerSelectMenu} from "../../components/forms/new-customer-selectmenu"
import { DomesticCustomerSelectMenu} from "../../components/forms/domestic-customer-selectmenu";
import { InternationalCustomerSelectMenu} from "../../components/forms/international-customer-selectmenu"

import { GroundHandlerContainer} from "../../views/noaccount/domestic/ground-handler"
import { ExistingCustomerContainer } from "../../views/noaccount/domestic/existing-customer"
import {IATAContainer} from "../../views/noaccount/international/iata-agent";
import {CompanyContainer} from "../../views/noaccount/international/company";
import {NewCompanyContainer} from "../../views/noaccount/domestic/new-customer/company";
import {NewCustomerContainer} from "../../views/noaccount/domestic/new-customer/myself";
import {Errors} from "../../api/util";
import * as constant from "../../../common/constant";
import scrollIntoViewIfNeeded from "scroll-into-view-if-needed";
import ReactDOM from "react-dom";

let NoAccountFormComponent = (props) => {

    let shipping = [
        {value: 'international', label: "Outside of Australia"},
        {value: 'domestic', label: "Within Australia"},
    ];

    return (
        <div className='registration-form'>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section>
                    <Field name="shipping"
                           onChange={(e,n,p) => { props.dispatch(Errors.clear());  props.dispatch(change('account' , 'customer' , { value : '' , label : ''})) }} options={shipping}
                           title="Are you shipping..." id="shipping" component={SelectMenu}/>
                </section>
                {props.children}
            </form>
        </div>
    )
};

NoAccountFormComponent = reduxForm({form: 'account', destroyOnUnmount: false})(NoAccountFormComponent);

class NoAccountFormContainer extends React.Component {

    isDomestic = () => {return this.props.account.shipping.value === "domestic"};
    isInternational = () => { return this.props.account.shipping.value === "international"};

    isCustomer = (type) => { return this.props.account.customer && this.props.account.customer.value === type };

    isExistingCustomer = () => { return this.isDomestic() && this.isCustomer(constant.FUNC_ROLE_CURRENT_QF_CUSTOMER)  };
    isGroundHandler = () => { return this.isDomestic() && this.isCustomer(constant.FUNC_ROLE_GROUND_HANDLER) };
    isNewCustomer = () => { return this.isDomestic() && this.isCustomer("new-customer") };

    isCompany = () => { return this.isInternational() && this.isCustomer("company") };
    isIATAAgent = () => { return this.isInternational() && this.isCustomer("agent") };

    asMySelf = () => {
        return this.isNewCustomer() && this.props.account.howtoregister && this.props.account.howtoregister.value === "myself";
    };

    asCompany = () => {
        return this.isNewCustomer() && this.props.account.howtoregister && this.props.account.howtoregister.value === "company";

    };

    componentWillMount = () => {
        this.props.dispatch(Errors.clear());
    };

    componentDidMount = () => {
        scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this._sivNode), false , {duration: 150});
    };

    render = () => {
        return (
            <div>
                <NoAccountFormComponent ref={(node) => { this._sivNode = node}} onSubmit={(values,dispatch,props) => {}}
                                        onSubmitSuccess={(result,dispatch,props) => {}}
                                        onSubmitFail={(errors,dispatch) => {}}>
                    {this.isDomestic() && <DomesticCustomerSelectMenu path={this.props.path}/>}
                    {this.isInternational() && <InternationalCustomerSelectMenu path={this.props.path}/>}
                    {this.isNewCustomer() && <NewCustomerSelectMenu path={this.props.path}/>}
                </NoAccountFormComponent>

                { this.isExistingCustomer() && <ExistingCustomerContainer path={this.props.path} handleSubmitSuccess={this.props.handleSubmitSuccess} />}
                { this.isGroundHandler() && <GroundHandlerContainer path={this.props.path} handleSubmitSuccess={this.props.handleSubmitSuccess} /> }


                { this.asMySelf() && <NewCustomerContainer path={this.props.path} handleSubmitSuccess={this.props.handleSubmitSuccess} /> }
                { this.asCompany() && <NewCompanyContainer path={this.props.path} handleSubmitSuccess={this.props.handleSubmitSuccess} /> }


                { this.isCompany() && <CompanyContainer path={this.props.path} handleSubmitSuccess={this.props.handleSubmitSuccess} />}
                { this.isIATAAgent() && <IATAContainer path={this.props.path} handleSubmitSuccess={this.props.handleSubmitSuccess} />}
            </div>
        )
    }
}

NoAccountFormContainer = connect(state => {

    return {
        config : getFormValues('config')(state),
        registration : getFormValues('registration')(state),
        account : getFormValues('account')(state),

    }

})(NoAccountFormContainer);

export {
    NoAccountFormContainer
}